import { useEffect, useState } from 'react'
import { isCargueroHabilitado } from './lotesRepository'

export const useIsCargueroHabilitado = () => {
  const [habilitado, setHabilitado] = useState(false)

  const fetch = async () => {
    isCargueroHabilitado().then(response => {
      if (response.ok) {
        setHabilitado(response.data?.result ?? false)
      } else {
        setHabilitado(false)
      }
    })
  }

  useEffect(() => {
    fetch()

    return () => {
      setHabilitado(false)
    }
  }, [])

  return { isCargueroHabilitado: habilitado, reload: fetch }
}
